import { IUserWorking } from 'store/modules/goal/types'
import { IStore } from 'store/modules/store/types'

type StoreWithUsers = Pick<IStore, '_id' | 'users'>

const getUserId = (user: IUserWorking) =>
  typeof user.userId === 'object' ? user.userId._id : user.userId

export const getStoreSellerUsers = (store: StoreWithUsers) =>
  store.users.filter(user => user.stores?.find(userStore => userStore.storeId === store._id)?.type === 'seller')

export const buildDefaultUsersWorking = (store: StoreWithUsers, dsr: number): IUserWorking[] =>
  getStoreSellerUsers(store).map(user => ({
    _id: '',
    active: true,
    dayOff: { enable: false },
    dsr: dsr > 0,
    goalWeight: 1,
    userId: {
      _id: user._id,
      name: user.name,
      photo: user.photo
    },
    weightLocked: false
  }))

export const buildUsersSelectionFromLastActiveGoal = (
  store: StoreWithUsers,
  lastActiveGoalUsers: IUserWorking[] | undefined,
  dsr: number
) => {
  const storeSellers = buildDefaultUsersWorking(store, dsr)
  if (lastActiveGoalUsers === undefined) {
    return { usersNotWorking: [], usersWorking: storeSellers }
  }

  const participatingUserIds = new Set(
    lastActiveGoalUsers.filter(user => user.active).map(getUserId)
  )

  return storeSellers.reduce(
    (selection, user) => {
      if (participatingUserIds.has(getUserId(user))) {
        selection.usersWorking.push(user)
      } else {
        selection.usersNotWorking.push({ ...user, active: false })
      }
      return selection
    },
    { usersNotWorking: [] as IUserWorking[], usersWorking: [] as IUserWorking[] }
  )
}
